import { Box, Fade } from '@mui/material';
import { SearchSummaryBackground } from '../SearchSummaryBackground';

interface SearchSummaryCardBackgroundProps {
  shouldRenderBackground: boolean;
}

const FADE_IN_ANIMATION_DURATION = 1000;

export const SearchSummaryCardBackground = ({
  shouldRenderBackground,
}: SearchSummaryCardBackgroundProps) => {
  return (
    <Box overflow="hidden">
      <Fade in={shouldRenderBackground} timeout={FADE_IN_ANIMATION_DURATION}>
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
          }}
        >
          <SearchSummaryBackground />
        </Box>
      </Fade>
      <Fade in={shouldRenderBackground} timeout={FADE_IN_ANIMATION_DURATION}>
        <Box
          sx={{
            position: 'absolute',
            right: 0,
            bottom: 0,
            transform: 'rotate(180deg)',
          }}
        >
          <SearchSummaryBackground />
        </Box>
      </Fade>
    </Box>
  );
};
